export const formatHref = path => {
  try {
    return new URL(path).href
  } catch (err) {
    return path ? `https://${path}` : path
  }
}

export const isUrl = path => {
  try {
    return !!new URL(path)
  } catch (err) {
    return false
  }
}

export const isHttps = path => {
  try {
    return new URL(path).protocol === 'https:'
  } catch (err) {
    return false
  }
}

export default { formatHref, isUrl, isHttps }
